import { render, staticRenderFns } from "./SponsorsManagement.vue?vue&type=template&id=46e65df9&"
import script from "./SponsorsManagement.vue?vue&type=script&lang=js&"
export * from "./SponsorsManagement.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports